import { Partnerships, PartnershipsProps } from "@kunduz/ui-components";
import { ComponentConfig } from "@measured/puck";
import { defaultComponentSize, defaultComponentSizeFields } from "../../utils";

export interface LogoSliderProps extends PartnershipsProps {}

const LogoSlider = (props: LogoSliderProps) => {
  return <Partnerships {...props} />;
};

export const PuckLogoSlider: ComponentConfig<LogoSliderProps> = {
  label: "Logo Slider",
  fields: {
    backgroundColor: { type: "text", label: "Background Color" },
    title: { type: "text", label: "Title" },
    imageUrls: {
      type: "array",
      label: "Image URLs",
      arrayFields: { image: { type: "text", label: "Image URL" } },
    },
    isSliding: {
      type: "radio",
      label: "Is Sliding",
      options: [
        { label: "Yes", value: true },
        { label: "No", value: false },
      ],
    },
    isTransparent: {
      type: "radio",
      label: "Is Transparent",
      options: [
        { label: "Yes", value: true },
        { label: "No", value: false },
      ],
    },
    pauseOnHover: {
      type: "radio",
      label: "Pause on Hover",
      options: [
        { label: "Yes", value: true },
        { label: "No", value: false },
      ],
    },
    slider: {
      type: "radio",
      label: "Enable Slider",
      options: [
        { label: "Yes", value: true },
        { label: "No", value: false },
      ],
    },
    options: {
      type: "object",
      label: "Options",
      objectFields: {
        ...(defaultComponentSizeFields as any),
      },
    },
  },
  defaultProps: {
    backgroundColor: "#fff",
    imageUrls: [{ image: "" }],
    isSliding: true,
    title: "",
    isTransparent: false,
    pauseOnHover: true,
    slider: true,
    options: {
      ...defaultComponentSize,
    },
  },
  render: (props) => <LogoSlider {...props} />,
};
